// TIM-family assessments: the original Teams in Motion team self-assessment and
// any as-is clones (currently "Executive Team Assessment"). Identical mechanics;
// they differ only by slug, display name and group/company category.
export const TIM_FAMILY = [
  { slug: "tim_self_assessment", category: "tim" },
  { slug: "executive_team_assessment", category: "executive" },
];
export const TIM_FAMILY_SLUGS = TIM_FAMILY.map((t) => t.slug);
export const TIM_FAMILY_CATEGORIES = TIM_FAMILY.map((t) => t.category);
export const slugForCategory = (category) => (TIM_FAMILY.find((t) => t.category === category) || {}).slug;
export const categoryForSlug = (slug) => (TIM_FAMILY.find((t) => t.slug === slug) || {}).category;
export const isTimFamilySlug = (slug) => TIM_FAMILY_SLUGS.includes(slug);
export const isTimFamilyCategory = (category) => TIM_FAMILY_CATEGORIES.includes(category);

// Display label for a participant's role/type. The stored values stay
// "member"/"senior"/"both"; only the visible label changes. The Executive
// assessment uses its own wording per client request.
export const roleLabel = (role, category) => {
  if (category === "executive") {
    if (role === "member") return "Executive Team Member";
    if (role === "senior") return "Executive Team Feedback Provider";
    if (role === "both") return "Member + Feedback Provider";
  }
  if (!role) return "";
  if (role === "both") return "Senior + Member";
  return role.charAt(0).toUpperCase() + role.slice(1);
};
